import { CustomViewRegister } from '../CustomView';
import { WbIcon, WbIconObjectProps } from '../WbIcon';

CustomViewRegister.register({
  id: 'icon',
  function: function IconView(props: Record<string, any>) {
    if (props.value) {
      return (
        <span style={{ display: 'flex' }}>
          {' '}
          <WbIcon icon={props as WbIconObjectProps} style={props.style} />{' '}
        </span>
      );
    }
    return <></>;
  },
});
